export default {
  path: '/wecode/enterprise',
  auth: false,
  preload: false,
  key: 'enterprise',
  component: () => import('./index')
};
